import { Platform } from 'react-native';

import { resolveLocalUrl } from '@sixam/shared/local-url';

export function getAppBaseUrl(): string {
  if (Platform.OS === 'web' && typeof window !== 'undefined') {
    return window.location.origin;
  }

  return resolveLocalUrl(
    process.env.EXPO_PUBLIC_APP_URL ?? 'http://127.0.0.1:8081',
    'app-base-url'
  );
}

export function getApiUrl(path: string): string {
  const baseUrl = getAppBaseUrl();
  const apiUrl = new URL(path, baseUrl).toString();

  if (__DEV__) {
    console.info('[6am api-url] resolved API URL', {
      baseUrl,
      path,
      resolvedUrl: apiUrl,
    });
  }

  return apiUrl;
}
